import { ICoding } from "@shared/interfaces/shared.interface";

export interface IImageUrls {
  path: string;
  caption: string;
}

export interface IEnableWhen {
  operator: string;
  question?: string; // must be the linkId of question need to be tested
  type: string;
  answer: string; // expected result to active the question (Can be String or Number, but stored as String)
  code?: ICode;
}

interface ICode {
  coding: ICoding[];
}

export enum QuestionnaireType {
  NORMAL = "NORMAL",
  QUIZ = "QUIZ",
  CONSENT = "CONSENT",
}

export enum InputType {
  RANGE = "RANGE",
  CHECKBOXES = "CHECKBOXES",
  RADIO = "RADIO",
  DROPDOWN = "DROPDOWN",
  STRING = "STRING",
  TEXT = "TEXT",
  TEXTFIELD = "TEXTFIELD",
  NUMBER = "NUMBER",
  DECIMAL = "DECIMAL",
  DATE = "DATE",
  TIME = "TIME",
  RATING = "RATING",
  CHOICE = "CHOICE",
  EXTERNAL_LINK = "EXTERNAL_LINK",
}
